import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Dropdown from "react-bootstrap/Dropdown";
import Pagination from "react-bootstrap/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  createClient,
  getAdmins,
  getBots,
  getClients,
  updateClient,
} from "../Redux/Actions/auth";
import { toast } from "react-toastify";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import NoData from "../Components/NoData";
import {
  capitalize,
  dateOfBookingEventWise,
  downloadCSV,
  formattedDate,
  truncateString,
} from "../Utils/commonFiles";
import PaginationComponent from "../Components/Pagination";
import SearchComponent from "../Components/CommanSearch";
import DeleteModal from "../Components/DeleteModal";
import AdminActions from "../Redux/Actions/AdminActions";

export default function Admins() {
  const adminList = useSelector((e) => e.userAuth.adminList);
  const ImageUrl = process.env.REACT_APP_IMG_URL;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const totalEntries = adminList?.pagination?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentAdminId, setCurrentAdminId] = useState("");

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handlePageChange = (page) => {
    setCurrentPage(page + 1);
    navigate(`/admin?page=${page + 1}`);
  };

  const [currentFaqId, setCurrentFaqId] = useState("");

  const handleChange = async (id) => {
    setCurrentAdminId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteAdmin = () => {
    dispatch(AdminActions.deleteAdmin({ adminId: currentAdminId })).then(
      (res) => {
        if (res?.payload?.status == 200) {
          toast.success(res?.payload?.message);
          Inialize();
        } else {
          toast.error(res?.payload?.message);
        }
        handleCloseDeleteModal();
      }
    );
  };

  const Inialize = () => {
    try {
      const params = new URLSearchParams(location.search);
      const page = params.get("page") || currentPage;
      setCurrentPage(page);
      const searchQuery = params.get("search") || "";
      const queryParams = searchQuery
        ? { name: searchQuery }
        : { page: page, limit };
      dispatch(startstopLoading(true));
      dispatch(getAdmins(queryParams)).then((res) => {
        dispatch(startstopLoading(false));
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Inialize();
  }, [location.search, dispatch, currentPage, location.pathname, limit]);
  return (
    <Layout>
      <Container fluid>
        <div className="filters">
          <div className="inner-filter-field">
            <div className="image-heading-text">
              <h2>Admins</h2>
            </div>
            <div className="user-search">
              <div className="drop-down">
                <div className="select-box">
                  <Form.Select
                    aria-label="Default select example"
                    onChange={(e) => setLimit(e.target.value)}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
              <div className="search-tab">
                <div className="input-search">
                  <SearchComponent heading="Admin" />
                </div>
                <div
                  onClick={() => navigate(`/add-new-admin`)}
                  className="export-box"
                >
                  <p>Add New Admin</p>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <Table size="sm" className="table-cmn">
                <thead>
                  <tr>
                    <th>S no.</th>
                    <th> Name</th>
                    <th>Email </th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {adminList?.adminList?.map((res, index) =>
                    <tr key={index}>
                      <td>
                        <div className="first-user">
                          <div className="user-id">
                            <p>{index + 1}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="user-role">
                          <p>{res?.firstName}</p>
                        </div>
                      </td>
                      <td>{res.email}</td>

                      <td>Admin</td>
                      <td>
                        <div className="action">
                          <div
                            onClick={() => handleChange(res._id)}
                          >
                            <img
                              src={
                                require("../Assets/Images/delete-icon.svg").default
                              }
                            />
                          </div>
                          <div
                            onClick={() => navigate(`/add-new-admin?id=${res._id}`)}
                          >
                            <img
                              src={
                                require("../Assets/Images/view-icon.svg").default
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                </tbody>
              </Table>
              {adminList?.pagination?.total > 1 && (
                <PaginationComponent
                  currentPage={currentPage - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  totalEntries={totalEntries}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </div>
          </div>
        </div>
        <div className="made-with">
          <div className="pixinvent">
            <p>
              {" "}
              © {new Date().getFullYear()}, Made with ❤️ by <span>Codobux</span>
            </p>
          </div>
        </div>
      </Container>
      <DeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDeleteAdmin}
        name={"Admin"}
      />
    </Layout>
  );
}
